import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { config } from "../../data/config";
import { useTranslation } from 'react-i18next';
import HeaderOfPage from "../tools/headerOfPage";
import { useNavigate, useParams } from 'react-router-dom';
import CountrySelector from './CountrySelector';
import countriesData from 'world-countries';
import * as Flags from 'country-flag-icons/react/3x2';

export default function ListTestimonialDetail() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { Id } = useParams();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Testimonial',
            url: '/dashboard/Testimonial'
        },
        {
            name: 'Group List',
            url: '/dashboard/Testimonial/GroupList'
        },
        {
            name: 'Testimonial Details',
            url: null
        },
    ]
    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    }
    const [key, setKey] = useState(1);

    return (
        <>
            <div className="bg-gray-50 min-h-screen p-4 md:p-6">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="Testimonial Details"></HeaderOfPage>

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mt-6">
                    <div className="lg:col-span-1" dir="rtl">
                        <NewTestimonialDetail parent={Id} reloaditem={reloadgame} key={key}></NewTestimonialDetail>
                    </div>
                    <div className="lg:col-span-3">
                        <ListofTestimonialDetail parent={Id} key={key}></ListofTestimonialDetail>
                    </div>
                </div>
            </div>
        </>
    )
}

function ListofTestimonialDetail({ parent }: any) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    let cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);

    const getalldata = async () => {
        setError(null);
        setLoading(true);

        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/testimonialdetail',
                params: { parent: parent },
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            setList(res.data.message.docs || res.data.message);
        } catch (error: any) {
            setError(error.response?.data?.message || t('Error loading testimonials'));
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error loading testimonials'),
            });
        } finally {
            setLoading(false);
        }
    }
    
    const deleted = async (id: any) => {
        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this testimonial!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!"),
            cancelButtonText: t('Cancel')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/testimonialdetail/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })

                    Swal.fire({
                        icon: 'success',
                        title: t('Deleted'),
                        text: t('Testimonial deleted successfully'),
                        timer: 1500,
                        showConfirmButton: false
                    });

                    getalldata();
                } catch (error: any) {
                    Swal.fire({
                        icon: 'error',
                        title: t('Error'),
                        text: error.response?.data?.message || t('Error deleting testimonial'),
                    });
                }
            }
        });
    }
    
    useEffect(() => {
        getalldata();
    }, [parent]);

    if (loading && !list) {
        return (
            <div className="bg-white rounded-xl shadow-sm p-8">
                <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                </div>
                <p className="text-center mt-4 text-gray-600">در حال بارگذاری...</p>
            </div>
        );
    }

    const getDisplayName = (name: any): string => {
        if (!name) return '';
        if (typeof name === 'string') return name;
        if (typeof name === 'object') {
            return name.en || name.fa || name.ku || name.ar || name.tr || '';
        }
        return String(name);
    };

    const displayList = Array.isArray(list) ? list : (list?.docs || []);

    return (
        <div className="space-y-4" dir="rtl">
            <div className="bg-white rounded-xl shadow-sm p-4">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <button
                            type="button"
                            onClick={() => getalldata()}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                        >
                            <div className="flex items-center gap-2">
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                                {t('Reload')}
                            </div>
                        </button>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                {error && (
                    <div className="p-4 bg-red-50 border-r-4 border-red-500 text-red-700">
                        {error}
                    </div>
                )}
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Title')}
                                </th>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Country')}
                                </th>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Date')}
                                </th>
                                <th scope="col" className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    {t('Action')}
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {displayList && displayList.length > 0 ? (
                                displayList.map((item: any) => {
                                    const displayTitle = getDisplayName(item.title);
                                    const date = item.date ? new Date(item.date).toLocaleDateString() : '-';
                                    return (
                                        <tr key={item._id || item.id} className="hover:bg-gray-50">
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm font-medium text-gray-900">{displayTitle || '-'}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="flex items-center gap-2 text-sm text-gray-500">
                                                    {item.country ? (
                                                        <>
                                                            {(() => {
                                                                try {
                                                                    const code = item.country.toUpperCase();
                                                                    const FlagComponent = (Flags as any)[code];
                                                                    return FlagComponent ? <FlagComponent className="w-4 h-4" title={item.country} /> : null;
                                                                } catch {
                                                                    return null;
                                                                }
                                                            })()}
                                                            <span>{(() => {
                                                                const country = countriesData.find(c => c.cca2 === item.country);
                                                                return country ? country.name.common : item.country;
                                                            })()}</span>
                                                        </>
                                                    ) : (
                                                        <span>-</span>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-gray-500">{date}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                                                <div className="flex items-center justify-center gap-2">
                                                    <button
                                                        onClick={() => navigate(`/dashboard/Testimonial/DetailEdit/${item._id || item.id}`)}
                                                        className="text-blue-600 hover:text-blue-900 px-3 py-1 rounded hover:bg-blue-50"
                                                    >
                                                        {t('Edit')}
                                                    </button>
                                                    <button
                                                        onClick={() => deleted(item._id || item.id)}
                                                        className="text-red-600 hover:text-red-900 px-3 py-1 rounded hover:bg-red-50"
                                                    >
                                                        {t('Delete')}
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={4} className="px-6 py-4 text-center text-sm text-gray-500">
                                        {t('No testimonials found')}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

function NewTestimonialDetail({ parent, reloaditem }: any) {
    const { t } = useTranslation();
    let cookie = getCookies();
    const [activeLang, setActiveLang] = useState<'ku' | 'fa' | 'en' | 'ar' | 'tr'>('en');
    const languages = [
        { code: 'ku' as const, label: 'Kurdish' },
        { code: 'fa' as const, label: 'فارسی' },
        { code: 'en' as const, label: 'English' },
        { code: 'ar' as const, label: 'العربية' },
        { code: 'tr' as const, label: 'Türkçe' }
    ];

    const [data, setData] = useState<any>({
        parent: parent,
        title: { ku: '', fa: '', en: '', ar: '', tr: '' },
        description: { ku: '', fa: '', en: '', ar: '', tr: '' },
        country: '',
        date: new Date().toISOString().split('T')[0],
        tags: { ku: [], fa: [], en: [], ar: [], tr: [] }
    });
    const [tagInput, setTagInput] = useState<string>('');
    const [saving, setSaving] = useState(false);

    const inputstyle = "py-3 px-5 block w-full border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:pointer-events-none bg-white text-gray-900";

    const getMultilingualValue = (field: any, lang: string): string => {
        if (!field) return '';
        if (typeof field === 'string') return field;
        if (typeof field === 'object') {
            return field[lang] || '';
        }
        return '';
    };

    const addTag = () => {
        if (tagInput.trim() && !data.tags[activeLang].includes(tagInput.trim())) {
            setData({
                ...data,
                tags: {
                    ...data.tags,
                    [activeLang]: [...data.tags[activeLang], tagInput.trim()]
                }
            });
            setTagInput('');
        }
    };

    const removeTag = (tag: string) => {
        setData({
            ...data,
            tags: {
                ...data.tags,
                [activeLang]: data.tags[activeLang].filter((t: string) => t !== tag)
            }
        });
    };

    const save = async () => {
        if (!data.title[activeLang] && !data.title.en && !data.title.fa && !data.title.ku && !data.title.ar && !data.title.tr) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: t('Title is required in at least one language'),
            });
            return;
        }

        if (!data.parent) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: t('Parent group is required'),
            });
            return;
        }

        setSaving(true);
        try {
            let res = await axios({
                method: 'post',
                data: data,
                url: config.url + '/v1/dashboard/testimonialdetail',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: t('Testimonial created successfully'),
                timer: 1500,
                showConfirmButton: false
            });
            setData({
                parent: parent,
                title: { ku: '', fa: '', en: '', ar: '', tr: '' },
                description: { ku: '', fa: '', en: '', ar: '', tr: '' },
                country: '',
                date: new Date().toISOString().split('T')[0],
                tags: { ku: [], fa: [], en: [], ar: [], tr: [] }
            });
            setTagInput('');
            reloaditem();
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error creating testimonial'),
            });
        } finally {
            setSaving(false);
        }
    }

    return (
        <div className="bg-white rounded-xl shadow-sm p-6" dir="rtl">
            <h2 className="text-lg font-bold text-gray-800 mb-4">{t('New Testimonial')}</h2>
            <form className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Language')}
                    </label>
                    <div className="flex gap-2 flex-wrap">
                        {languages.map((lang) => (
                            <button
                                key={lang.code}
                                type="button"
                                onClick={() => setActiveLang(lang.code)}
                                className={`px-3 py-1.5 text-xs font-medium rounded-lg transition-colors ${
                                    activeLang === lang.code
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                }`}
                            >
                                {lang.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Title')} ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={getMultilingualValue(data.title, activeLang)}
                        className={inputstyle}
                        placeholder={t('Enter title')}
                        onChange={(e) => setData({
                            ...data,
                            title: {
                                ...data.title,
                                [activeLang]: e.target.value
                            }
                        })}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Description')} ({languages.find(l => l.code === activeLang)?.label})
                    </label>
                    <textarea
                        value={getMultilingualValue(data.description, activeLang)}
                        rows={4}
                        className={inputstyle}
                        placeholder={t('Enter description')}
                        onChange={(e) => setData({
                            ...data,
                            description: {
                                ...data.description,
                                [activeLang]: e.target.value
                            }
                        })}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Country')}
                    </label>
                    <CountrySelector
                        value={data.country}
                        onChange={(value) => setData({ ...data, country: value })}
                        placeholder={t('Select country')}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Date')}
                    </label>
                    <input
                        type="date"
                        value={data.date}
                        className={inputstyle}
                        onChange={(e) => setData({ ...data, date: e.target.value })}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t('Tags')} ({languages.find(l => l.code === activeLang)?.label})
                    </label>
                    <div className="flex gap-2 mb-2">
                        <input
                            type="text"
                            value={tagInput}
                            className={inputstyle}
                            placeholder={t('Enter tag and press Enter')}
                            onChange={(e) => setTagInput(e.target.value)}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    addTag();
                                }
                            }}
                        />
                        <button
                            type="button"
                            onClick={addTag}
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                        >
                            {t('Add')}
                        </button>
                    </div>
                    <div className="flex flex-wrap gap-2">
                        {data.tags[activeLang].map((tag: string, index: number) => (
                            <span
                                key={index}
                                className="inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm"
                            >
                                {tag}
                                <button
                                    type="button"
                                    onClick={() => removeTag(tag)}
                                    className="text-blue-600 hover:text-blue-800"
                                >
                                    ×
                                </button>
                            </span>
                        ))}
                    </div>
                </div>

                <button
                    type="button"
                    onClick={save}
                    disabled={saving}
                    className="w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                    {saving ? t('Saving...') : t('Save')}
                </button>
            </form>
        </div>
    );
}

